// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../../engines/gameEngine";
import data_control from "../../../../../engines/libs/data_control";
import PromiseUtil from "../../../../../engines/libs/PromiseUtil";
import utilsModel from "../../../../../engines/libs/utilsModel";
import { MessageEventKind } from "../../../../define/MessageEventKind";
import NormalGameManager from "../../../manager/NormalGameManager";
import { TouchCardKind } from "../common/data/TouchCardKind";
import TouchCardItemBase from "../common/TouchCardItemBase";
import ChooseCardChallengeLayer from "./ChooseCardChallengeLayer";
import { ChooseCardKind } from "./data/ChooseCardKind";

const {ccclass, property} = cc._decorator;

@ccclass
export default class ChooseCardChallengeResult extends BasePopUpLayer {

	@property({ type: cc.Node, displayName:'' })
	btnAnew: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeLose: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeWin: cc.Node = null;

    @property({ type: cc.Node, displayName:'' })
	nodeVideo: cc.Node = null;

    @property({ type: cc.Node, displayName:'' })
	nodeGold: cc.Node = null;

    @property({ type: cc.Node, displayName:'' })
	cardParent: cc.Node = null;

	@property({ type: cc.Label, displayName:'' })
	labelGold: cc.Label = null;

    private lotteryInfo: TouchCardKind.ItemInfo = null;
    private cardData: number = null;
    private _parent: ChooseCardChallengeLayer = null;

    private itemScirpt: TouchCardItemBase = null;

    private bwin: boolean = false;
    private bCanAnewOne: boolean = false;
    private idx: number = 0;
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        this.refreshState();

        this.itemScirpt = this.cardParent.getChildByName('TouchCardItemBase').getComponent(TouchCardItemBase);
        this.itemScirpt.setData(this.cardData);

        this.nodeLose.active = !this.bwin;
    	this.nodeWin.active = this.bwin;
        this.btnAnew.active = !this.bwin;

        if (this.bwin) {
            PromiseUtil.nextFrame().then(()=> {
                // 胜利
                let gold = ChooseCardKind.GeneralValue.AWARD_NUM;
                O1HD.getServices().userSrv.setCoins(gold, true, this.cardParent);
            });
        } else {
            if (!this.bCanAnewOne) {
                this.btnAnew.active = false;
            }
        }
    }

    resetData() {
        
    }

    setData(
        cardData: number
        , _parent: ChooseCardChallengeLayer
        , lotteryInfo: TouchCardKind.ItemInfo
        , bwin: boolean
        , bCanAnewOne: boolean
        , idx: number
    ) {
        this.idx = idx;
        this.bwin = bwin;
        this.lotteryInfo = lotteryInfo;
        this.cardData = cardData;
        this._parent = _parent;
        this.bCanAnewOne = bCanAnewOne;
    }

    getLotteryInfo() {
        let lotteryInfo: TouchCardKind.ItemInfo = this.lotteryInfo;
        return lotteryInfo;
    }

    showPrice() {
        let lotteryInfo = this.getLotteryInfo();
        let strPrice = data_control.getNumberFormat(lotteryInfo.price);
        this.labelGold && (this.labelGold.string = strPrice);
        // this.labelPrice && (this.labelPrice.string = '面值' + strPrice);
    }

    refreshState() {
        let lotteryInfo = this.getLotteryInfo();

        let gameData = NormalGameManager._instance.getGameData();
        let count = gameData.curTouchCardNum[lotteryInfo.idx] || 0;
        let bShowVideo = count >= lotteryInfo.limitCount;
        this.nodeVideo.active = bShowVideo;
        this.nodeGold.active = !bShowVideo;
        this.labelGold.node.active = !bShowVideo;

        this.showPrice();
    }

    onClickBuy() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        if (this.nodeVideo.active) {
            utilsModel.loadAndShowVideoAdTrans(()=>{
                // this.resetStartLottery();
                this.resetStart();
                
            },()=>{
                O1HD.getModules().uiControlModule.showMessageBox("观看视频失败");
            },()=>{
    
            },"观看视频获得摸牌玩法次数");
        } else {
            let lotteryInfo = this.getLotteryInfo();
            let needPayPrice : number = lotteryInfo.price;
            if ( O1HD.getServices().userSrv.getCoins() < needPayPrice ) {
                O1HD.getModules().uiControlModule.showMessageBox("金额不足",this.node );
                
                NormalGameManager._instance.openBankPage();
                return;
            }
            O1HD.getServices().userSrv.setCoins( -needPayPrice,true );
            // this.resetStartLottery();
            let gameData = NormalGameManager._instance.getGameData();
            gameData.curTouchCardNum[lotteryInfo.idx] = gameData.curTouchCardNum[lotteryInfo.idx] || 0;
            gameData.curTouchCardNum[lotteryInfo.idx]++;
            NormalGameManager._instance.writeGameData();
            // this.refreshState();
            this.resetStart();

            O1HD.emit(MessageEventKind.EventName.UPDATE_LOTTERY_LIST);
        } 
    }

    resetStart() {
        this.destroyNode();
        this._parent.resetData();
    }

    anewOneCard() {
        this.destroyNode();
        this._parent.anewOneCard(this.idx);
    }

    onClickAnew() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();

        utilsModel.loadAndShowVideoAdTrans(()=>{
            this.anewOneCard();
        },()=>{
            O1HD.getModules().uiControlModule.showMessageBox("观看视频失败");
        },()=>{

        },"观看视频获得摸牌玩法再来一张");
    }

    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.destroyNode();
    }

    // update (dt) {}
}
